import { render, staticRenderFns } from "./base-field-layout.vue?vue&type=template&id=00ba6df4&scoped=true"
import script from "./base-field-layout.vue?vue&type=script&lang=ts"
export * from "./base-field-layout.vue?vue&type=script&lang=ts"
import style0 from "./base-field-layout.vue?vue&type=style&index=0&id=00ba6df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba6df4",
  null
  
)

export default component.exports